module.exports = __webpack_public_path__ + "media/assets/fonts/Calibri-Regular-29c57b05b7345f94042a40bee9630bb3.ttf";